// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\NotificationStatsResponse

export type NotificationStatsApiResponse = {
	unread: number;
	unreadReviews: number;
};

export type NotificationStats = {
	unread: number;
	unreadReviews: number;
};

export function hydrateNotificationStats(data: NotificationStatsApiResponse): NotificationStats {
	return { ...data };
}